import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaArrowLeft } from 'react-icons/fa';
import { userApi } from '../api/userApi';
import { networkApi } from '../api/networkApi';
import { LoadingSpinner } from '../components/common/LoadingSpinner';
import { UserDetailTabs } from '../components/user/UserDetailTabs';

export const UserDetailPage = () => {
  const { networkId, networkCode, userId, code, personCode } = useParams();
  const navigate = useNavigate();
  const [user, setUser] = useState(null);
  const [network, setNetwork] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchUserAndNetwork = async () => {
      try {
        setLoading(true);

        // First, fetch the network if networkCode is provided
        if (networkCode) {
          console.log('Fetching network by subdomain:', networkCode);
          const networkData = await networkApi.getNetworkBySubdomain(networkCode);
          setNetwork(networkData);
        }

        let result;

        // If personCode is provided (from /person/:personCode or /n/:networkCode/person/:personCode)
        if (personCode) {
          console.log('Searching user by person code:', personCode);
          result = await userApi.findUserByCodeFull(personCode);
        }
        // If code is provided (from /user/code/:code), search by code using RootIdentityUrl
        else if (code) {
          console.log('Searching user by code:', code);
          result = await userApi.findUserByCodeFull(code);
        }
        // Otherwise, search by userId
        else if (userId) {
          // Use BusinessNetworkId=0 when no networkId is provided (for /user/:userId route)
          const preferredNetworkId = networkId !== undefined ? parseInt(networkId) : 0;
          result = await userApi.findUserByIdFull(userId, preferredNetworkId);
        }

        setUser(result.user);
        setError(result.user ? null : 'User not found');
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };
    fetchUserAndNetwork();
  }, [networkId, networkCode, userId, code, personCode]);

  if (loading) return <LoadingSpinner />;
  if (error) return <div className="alert alert-danger">Error loading user</div>;
  if (!user) return <div className="alert alert-danger">User not found</div>;

  return (
    <div className="fade-in">
      {/* Enhanced Back Button */}
      <button
        className="btn mb-4"
        onClick={() => navigate(-1)}
        style={{
          background: 'linear-gradient(135deg, #6366f1, #8b5cf6)',
          color: 'white',
          border: 'none',
          borderRadius: '12px',
          padding: '12px 24px',
          fontSize: '0.9rem',
          fontWeight: '600',
          boxShadow: '0 4px 12px rgba(99, 102, 241, 0.3)',
          transition: 'all 0.3s ease'
        }}
        onMouseEnter={(e) => {
          e.target.style.transform = 'translateY(-2px)';
          e.target.style.boxShadow = '0 8px 20px rgba(99, 102, 241, 0.4)';
        }}
        onMouseLeave={(e) => {
          e.target.style.transform = 'translateY(0)';
          e.target.style.boxShadow = '0 4px 12px rgba(99, 102, 241, 0.3)';
        }}
      >
        <FaArrowLeft className="me-2" />
        Back to Previous Page
      </button>

      {/* Tab Container */}
      <div className="card shadow-lg" style={{
        background: 'linear-gradient(135deg, #ffffff 0%, #f8fafc 100%)',
        borderRadius: '20px',
        border: '1px solid rgba(99, 102, 241, 0.1)',
        overflow: 'hidden'
      }}>
        <UserDetailTabs user={user} network={network} networkId={networkId || network?.businessNetworkID || '0'} />
      </div>
    </div>
  );
};